import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import {
  TextAreaFormField,
  Toggle,
  ContainerToggle,
  TextToggle,
} from '@playbookux/playbook-web-core';

import {
  Container,
  ContainerTitle,
  IconTitle,
  Title,
  TextLink,
  QuestionIndex,
} from './styles';

import ErrorMessage from '../error';

const Task = (props) => {
  const {
    index,
    errors,
    touched,
    isEdit,
    setFieldValue,
    question: {
      blurVideo,
    },
    taskIndex,
    testType,
  } = props;

  let isBlurVideo = '';
  let label = '';
  let showToggleBlurVideo = true;
  let title = 'Task/Question';

  if (testType === 'survey') {
    title = 'Instructions';
    showToggleBlurVideo = false;
    isBlurVideo = `${(taskIndex || taskIndex === 0) ? `surveysPages[${taskIndex}]` : ''}tasks.${index}.blurVideo`;
    label = `${(taskIndex || taskIndex === 0) ? `surveysPages[${taskIndex}]` : ''}tasks.${index}.label`;
  } else {
    isBlurVideo = `tasks.${index}.blurVideo`;
    label = `tasks.${index}.label`;
  }

  const handleClickToggle = () => {
    if (!isEdit) {
      setFieldValue(isBlurVideo, !blurVideo, false);
    }
  };

  return (
    <Container>
      <ContainerTitle>
        <QuestionIndex>{index + 1}</QuestionIndex>
        <IconTitle src="/images/question-task.png" />
        <Title color="questionTitleTask">
          {title}
        </Title>
      </ContainerTitle>
      <Field
        placeholder="Start typing your question"
        minWidth="100%"
        component={TextAreaFormField}
        name={label}
      />
      {showToggleBlurVideo && (
        <ContainerToggle>
          <Toggle
            onChange={handleClickToggle}
            checked={blurVideo}
            id={`istoggle-id-unique-${index}`}
            name="blurVideo"
            disabled={isEdit}
          />
          <TextToggle>
            Blur video to hide
            {' '}
            <TextLink
              href="http://help.playbookux.com/en/articles/4662502-hide-personal-information"
              target="_blank"
            >
              personal information
            </TextLink>
          </TextToggle>
        </ContainerToggle>
      )}

      <ErrorMessage
        index={index}
        errors={errors}
        touched={touched}
      />
    </Container>
  );
};

Task.propTypes = {
  index: PropTypes.number.isRequired,
  errors: PropTypes.shape({}).isRequired,
  touched: PropTypes.shape({}).isRequired,
  isEdit: PropTypes.bool.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  question: PropTypes.shape({
    blurVideo: PropTypes.bool,
  }),
  taskIndex: PropTypes.number,
  testType: PropTypes.string.isRequired,
};

Task.defaultProps = {
  question: PropTypes.shape({
    blurVideo: false,
  }),
  taskIndex: null,
};

export default Task;
